//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressPopup from './addressPopup.vue'
export default {
    components: {
        addressPopup
    },
    data() {
        return {
            type: 1,
            popupShow: false,
            defaultAddr: false,
            form: {
                name: '',
                phoneNum: '',
                address: ''
            },
            addressList: [],
            addressStr: '',
            inputDisable: true //解决自动聚焦的问题
        }
    },
    methods: {
        clickHandle(el) {
            $(el).focus();
        },
        closePopup() {
            this.type = 1;
            this.popupShow = false;
            this.defaultAddr = false;
            this.form = {
                name: '',
                phoneNum: '',
                address: ''
            };
            this.addressList = [];
            this.addressStr = '';
            this.$refs.addressPopupRef.closePopup();
            this.inputDisable = true;
        },
        showPopup(type, item) {
            this.popupShow = true;
            this.type = type;
            //编辑操作
            if(type == 2 && item) {
                this.form = JSON.parse(JSON.stringify(item));
                this.defaultAddr = (item.defaultAddress == 1);
                this.addressStr = item.regionDesc.replace(/\s/g, '\/');
                var regionArr = item.regionDesc.split(" ");
                var addressList = [];
                if(regionArr[0]) {
                    addressList.push({
                        regionName: regionArr[0],
                        regionId: item.province,
                    })
                }
                if(regionArr[1]) {
                    addressList.push({
                        regionName: regionArr[1],
                        regionId: item.city,
                    })
                }
                if(regionArr[2]) {
                    addressList.push({
                        regionName: regionArr[2],
                        regionId: item.prefecture,
                    })
                }
                if(regionArr[3]) {
                    addressList.push({
                        regionName: regionArr[3],
                        regionId: item.town,
                    })
                }
                this.addressList = addressList;
            }
            this.$nextTick(() => {
                this.inputDisable = false;
            })
        },
        submit() {
            let that = this;
            var one = this.form;
            if(!one.name) {
                that.$vux.toast.text('请填写收货人姓名')
                return false;
            }
            if(!one.phoneNum) {
                that.$vux.toast.text('请填写收货人手机号')
                return false;
            }
            if(!this.addressList || this.addressList.length <= 0) {
                that.$vux.toast.text('请选择省/市/区')
                return false;
            }
            if(!one.address) {
                that.$vux.toast.text('请填写街道门牌、楼层房间号等信息')
                return false;
            }
            var receiverAddress = {
                defaultAddress: that.defaultAddr?1:0,
                name: one.name,
                phoneNum: one.phoneNum.replace(/\s/g,""),
                address: one.address,
                addressLabel: ''
            }
            if(this.addressList) {
                receiverAddress.province = this.addressList[0] ? this.addressList[0].regionId : '';
                receiverAddress.city = this.addressList[1] ? this.addressList[1].regionId : '';
                receiverAddress.prefecture = this.addressList[2] ? this.addressList[2].regionId : '';
                receiverAddress.town = this.addressList[3] ? this.addressList[3].regionId : '';
                receiverAddress.regionDesc = this.addressList.map((item) => {
                    return item.regionName
                }).join(" ");
            }
            //编辑操作
            if(this.type == 2) {
                receiverAddress.receiverAddressId = one.receiverAddressId;
                receiverAddress.accountId = one.accountId;
            }
            var data = {
                receiverAddress: JSON.stringify(receiverAddress),
                shopperId: this.$store.state.userInfo.shopperId
            }
            this.ajaxSubmit(data);
        },
        ajaxSubmit(data) {
            let that = this;
            that.$axios.post('/api/v1.0/lonbonShop/saveReceiverAddress', that.qs.stringify(data)).then(function (response) {
                if(response.status == 200) {
                    that.$vux.toast.text('保存成功');
                    that.closePopup();
                    that.$emit("loadList");
                    that.$emit('onItemClick', JSON.parse(data.receiverAddress));
                }
            })
        },
        selectAddressHandle(list) {
            this.addressList = list;
            var arr = this.addressList.map((item) => {
                return item.regionName;
            })
            this.addressStr = arr.join("/");
        },
        deleteAddr() {
            let that = this;
            that.$vux.confirm.show({
                content: `确定要删除该地址吗？`,
                cancelText: '取消',
                confirmText: '删除',
                title: '提示',
                onConfirm () {
                    var data = {
                        receiverAddressId: that.form.receiverAddressId
                    }
                    that.$axios.post('/api/v1.0/lonbonShop/deleteReceiverAddress', that.qs.stringify(data)).then(function (response) {
                        if(response.status == 200) {
                            that.$vux.toast.text('删除成功');
                            that.closePopup();
                            that.$emit("loadList");
                        }
                    })
                }
            })
        },
        changeBtn(display) {
            $("#address-btn").css("display", display);
        },
        windowResize() {
            let that = this;
            var windowHeight = $(window).height();
            $(window).resize(function () {
                setTimeout(() => {
                    var changeHeight = $(window).height();
                    if(changeHeight < windowHeight) {
                        //焦点移入
                        console.log("焦点移入")
                        that.changeBtn("none");
                    } else {
                        //焦点移出
                        console.log("焦点移出")
                        that.changeBtn("block");
                    }
                }, 100);
            })
        },
    },
    mounted() {
        this.windowResize();
    }
}



// WEBPACK FOOTER //
// ./src/components/address/addressManage.vue